import Cookies from 'js-cookie';
import { BRANDS, BrandKey, isBrandKey } from './brands';

export const BRAND_HINT_STORAGE_KEY = 'cpq.teamarg.project';

export const readBrandHint = (): BrandKey | undefined => {
  try {
    const value = window.localStorage.getItem(BRAND_HINT_STORAGE_KEY);
    return value && isBrandKey(value) ? value : undefined;
  } catch {
    return undefined;
  }
};

export const writeBrandHint = (key: BrandKey) => {
  try {
    window.localStorage.setItem(BRAND_HINT_STORAGE_KEY, key);
  } catch {
    // Storage is blocked: the hint is a convenience, the served project still decides.
  }
};

export const applyPreMountPolicy = (hint: BrandKey | undefined = readBrandHint()) => {
  if (hint && BRANDS[hint].freshSessionOnLoad) {
    try {
      Cookies.remove('sessionId');
    } catch {
      // Cookies are blocked: the page starts without a session either way.
    }
  }
};
